import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M17.846 3.203a2.35 2.35 0 0 0-1.81-.846H3.333L3.3 2.081A2.357 2.357 0 0 0 .96 0H.786a.786.786 0 0 0 0 1.571H.96a.786.786 0 0 1 .78.694l1.082 9.193a3.93 3.93 0 0 0 3.901 3.47h8.206a.786.786 0 0 0 0-1.57H6.723a2.36 2.36 0 0 1-2.215-1.572h9.365a3.93 3.93 0 0 0 3.867-3.232l.617-3.42a2.35 2.35 0 0 0-.511-1.93m-1.032 1.651-.617 3.421a2.36 2.36 0 0 1-2.324 1.94H4.258l-.74-6.286h12.518a.786.786 0 0 1 .778.925M5.501 18.858a1.571 1.571 0 1 0 0-3.143 1.571 1.571 0 0 0 0 3.143M13.36 18.858a1.571 1.571 0 1 0 0-3.143 1.571 1.571 0 0 0 0 3.143" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18.857v18.857H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }